import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/db/client";
import { useState, useEffect } from "react";

export const useUserProfile = () => {
  const [userId, setUserId] = useState<string | null>(null);

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      setUserId(session?.user.id || null);
    });

    const {
      data: { subscription },
    } = supabase.auth.onAuthStateChange((event, session) => {
      setUserId(session?.user.id || null);
    });

    return () => subscription.unsubscribe();
  }, []);

  const query = useQuery({
    queryKey: ["user-profile", userId],
    queryFn: async () => {
      if (!userId) return null;

      const { data: profile } = await supabase
        .from("profiles")
        .select("first_name, last_name, email, avatar_url")
        .eq("id", userId)
        .single();

      return profile;
    },
    enabled: !!userId,
    staleTime: 10 * 60 * 1000, // Cache for 10 minutes
    gcTime: 15 * 60 * 1000, // Keep in cache for 15 minutes
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    placeholderData: (previousData) => previousData, // Keep showing old data while refetching
  });

  return { ...query, userId };
};
